import React from 'react';
import PropTypes from 'prop-types';

// Utilities.
import { getTerms } from 'app/client/utilities/search';

// Styled.
import * as S from './styled';

const escapeRegExp = (term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Cut a window around the first match so a long text stays readable in a table cell.
 */
const getExcerpt = (text, pattern, length) => {
  if (length === null || text.length <= length) return text;

  const match = text.search(new RegExp(pattern, 'i'));
  const start = Math.max(0, (match === -1 ? 0 : match) - Math.round(length / 3));
  const end = Math.min(text.length, start + length);

  return [start > 0 ? '…' : '', text.slice(start, end), end < text.length ? '…' : ''].join('');
};

const Highlight = ({ text, value, length = null }) => {
  const content = String(text ?? '');
  const terms = getTerms(value).map(escapeRegExp);

  if (content === '' || terms.length === 0) return content;

  const pattern = terms.join('|');

  // Splitting on a capture group puts the matches on the odd indexes.
  return getExcerpt(content, pattern, length)
    .split(new RegExp(`(${pattern})`, 'gi'))
    .map((part, index) =>
      index % 2 === 0 ? part : <S.Mark key={`${index}-${part}`}>{part}</S.Mark>,
    );
};

Highlight.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  length: PropTypes.number,
};

export default Highlight;
